import { useEffect, useState } from 'react';
import { useAppStore } from '../../store/useAppStore';

interface HelperProps {
  type: 'scroll' | 'click';
}

export const Helper: React.FC<HelperProps> = ({ type }) => {
  const [show, setShow] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);
  const { isInitialAnimationComplete, hasScrolled, selectedIndex } =
    useAppStore();

  useEffect(() => {
    if (selectedIndex !== null && !hasClicked) {
      setHasClicked(true);
    }
  }, [selectedIndex]);

  useEffect(() => {
    if (type === 'scroll') {
      if (
        isInitialAnimationComplete &&
        !hasScrolled &&
        selectedIndex === null
      ) {
        const timer = setTimeout(() => setShow(true), 500);
        return () => clearTimeout(timer);
      }
      if (show) setIsExiting(true);
    } else if (type === 'click') {
      if (hasScrolled && !hasClicked && selectedIndex === null) {
        const timer = setTimeout(() => setShow(true), 500);
        return () => clearTimeout(timer);
      }
      if (show) setIsExiting(true);
    }
  }, [
    isInitialAnimationComplete,
    hasScrolled,
    hasClicked,
    type,
    selectedIndex,
    show,
  ]);

  const handleTransitionEnd = (e: React.TransitionEvent) => {
    if (e.propertyName === 'opacity' && isExiting) {
      setShow(false);
      setIsExiting(false);
    }
  };

  if (!show && !isExiting) return null;

  return (
    <div
      className={`fixed text-black z-[25] pointer-events-none left-1/2 -translate-x-1/2 bottom-14 md:left-8 md:bottom-8 md:translate-x-0 transition-opacity duration-300 ${isExiting ? 'opacity-0' : 'opacity-100'}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <div className={`w-[min(92vw,420px)] pointer-events-none px-6 py-2.5 rounded-full bg-white/70 backdrop-blur-sm md:w-auto md:bg-transparent md:backdrop-blur-none md:px-0 md:py-0 md:rounded-none ${isExiting ? '' : 'animate-float'}`}>
        <div
          className="body opacity-0 text-center md:text-left"
          style={{
            animation: 'fade-in 0.6s ease-out forwards',
          }}
        >
          {type === 'scroll'
            ? 'Scroll to explore my work'
            : 'Select a project for more information'}
        </div>
      </div>
    </div>
  );
};

export const ScrollHelper = () => <Helper type="scroll" />;
export const ClickHelper = () => <Helper type="click" />;
